import React, { useState } from 'react';
import { Copy } from 'react-feather';
import { Logger } from "./Logger";

export const ToggleContainer = props => {

    const [visible, setVisible] = useState(null);

    return (
        <div className={visible ? 'toggleContainer' : 'toggleContainer'}>
            {visible
                ? <div>{props.children}</div>
                : <div className='toggle'><span onClick={() => { setVisible(true) }}>{props.title}</span></div>
            }
        </div>
    )
}


export const CodeBlock = props => {

    const copyToClipboard = () => {
        var text = props.onCopyToClipboard();
        navigator.clipboard.writeText(text)
            .then(() => {
                Logger.writeDebug('Copied Data to Clipboard');
        }, err => {
                Logger.writeError('Could not copy data to clipboard', err);
        });
    }

    return (
        <div className='codeblock'>

            {props.onCopyToClipboard &&
                <div className='toolbar'>
                    <Copy className='icon pull-right' title='Copy to Clipboard' onClick={() => { copyToClipboard(); }} />
                </div>
            }
            <p>
                {props.children}
            </p>
        </div>
    )

}